import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = ({ setIsLoggedIn }) => {
    const [username, setUsername] = useState('');  // 存储用户名状态
    const [password, setPassword] = useState('');  // 存储密码状态
    const navigate = useNavigate();  // 用于导航到不同的路由

    useEffect(() => {
        // 组件挂载时检查是否已有登录状态
        console.log('Checking login status in localStorage...');
        const loggedIn = localStorage.getItem('isLoggedIn');
        if (loggedIn === 'true') {
            console.log('User is already logged in. Redirecting to home page...');
            setIsLoggedIn(true);  // 设置登录状态
            navigate('/');  // 导航到首页
        } else {
            console.log('No existing login found.');
        }
    }, [setIsLoggedIn, navigate]);

    const handleLogin = (e) => {
        e.preventDefault();  // 阻止表单默认提交行为
        console.log('Attempting to log in with username:', username);

        // 校验用户名和密码
        if (username === 'yedepeng' && password === 'Yedepeng@818') {
            console.log('Login successful. Storing login state in localStorage...');
            setIsLoggedIn(true);  // 设置登录状态
            localStorage.setItem('isLoggedIn', 'true');  // 将登录状态存储到 localStorage
            localStorage.setItem('username', username);  // 存储用户名到 localStorage
            navigate('/');  // 登录成功后导航到首页
        } else {
            console.log('Invalid login attempt with username:', username);
            alert('Invalid username or password');  // 登录失败弹出提示
        }
    };

    return (
        <div className="container">
            <h2>Login</h2>
            <form onSubmit={handleLogin}>
                <div className="mb-3">
                    <label htmlFor="username" className="form-label">Username</label>
                    <input
                        type="text"
                        className="form-control"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}  // 监听用户名输入变化
                        required
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input
                        type="password"
                        className="form-control"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}  // 监听密码输入变化
                        required
                    />
                </div>
                <button type="submit" className="btn btn-primary">Login</button>
            </form>
        </div>
    );
};

export default Login;
